import React, {PropsWithChildren} from 'react';
import {colors} from 'patient-ping-remedy/packages/theme';
import {globalStyles, Wrapper, Image, Heading, Content, List, Footer}
  from '@/components/pages/error_pages/ErrorPage.styles';
import gif from '@/assets/gifs/error.gif';
import Spacer from "patient-ping-remedy/packages/spacer";
import {StandardSemiBoldTypography} from "patient-ping-remedy/packages/typography";

type Props = PropsWithChildren & {
  title?: string;
}

export default function ErrorPage(props: Props) {
  const apiErrorTraceId = sessionStorage.getItem('last_error_trace_id');
  return (
    <Wrapper>
      <style>{globalStyles.styles}</style>
      <Image src={gif} alt="error" />
      <Heading color={colors.charcoal}>{props.title || 'Oops! Something went wrong.'}</Heading>
      <Content>
        {props.children || (
          <>
            {apiErrorTraceId && (
              <span>
                Support code: <Spacer/>
                <StandardSemiBoldTypography>{apiErrorTraceId}</StandardSemiBoldTypography>
              </span>
            )}
            <span>The page you are trying to access is currently unavailable. Please try the following:</span>
            <List>
              <li>Refresh the page.</li>
              <li>Check your internet connection.</li>
              <li>Come back later.</li>
            </List>
            <span>If the problem persists, please contact your account manager.</span>
            <span>Thank you for your patience.</span>
          </>
        )}
      </Content>
      <Footer>©{new Date().getFullYear()} Bamboo Health</Footer>
    </Wrapper>
  );
}
